"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtrlEnter = exports.toasty = exports.isEmail = void 0;
var react_toastify_1 = require("react-toastify");
function isEmail(email) {
    return !!email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi);
}
exports.isEmail = isEmail;
function toasty(_a) {
    var message = _a.message, type = _a.type, _b = _a.position, position = _b === void 0 ? 'bottom-right' : _b;
    react_toastify_1.toast[type](message, {
        position: position,
        autoClose: 5000,
        hideProgressBar: true,
        pauseOnHover: false,
    });
}
exports.toasty = toasty;
/**
 * Check if a given keyboard event is ctrl + enter.
 */
function isCtrlEnter(event) {
    // keyCode 10 OR 13 is enter (https://stackoverflow.com/questions/1684196/ctrl-enter-using-jquery-in-a-textarea)
    return event.ctrlKey && (event.keyCode === 10 || event.keyCode === 13);
}
exports.isCtrlEnter = isCtrlEnter;
